

























import { OZUser } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WUserView extends BaseComponent {
	@Prop({ type: OZUser, required: true })
	user!: OZUser;
}
